import React from 'react';

import CDNImage from '../../common/cdn-image';

const ProductImageContainer = props => {
  return (
    <button
      className="product-view__image-container"
      onClick={() => props.showLightbox(0) }
    >
      <div className="product-view__image-container__wrapper">
        <CDNImage
          imagePath={props.data.Image_File_Path}
          alt={props.data.Name}
          width={640}
        />
      </div>
    </button>
  );
};

export default ProductImageContainer;